//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"AngleExpression",0,"Expression",0],[0,"CheckCollision",1,0],[0,"ClearanceCollision",1,0],[0,"CollisionCheckOption",1,0],[0,"EndAngle",1,0],[0,"GotoRun",1,0],[0,"HighlightCollision",1,0],[0,"IgnoreTouching",1,0],[1,"IntervalDimension",0,"Expression",0],[0,"StartAngle",1,0],[0,"StopCheckCollision",1,0],[1,"TimeExpression",0,"Expression",0]],[[[],"GotoStart",{},0,0],[[],"Previous",{},0,0],[[],"PlayBackwards",{},0,0],[[],"Play",{},0,0],[[],"Next",{},0,0],[[],"GotoEnd",{},0,0],[[],"Stop",{},0,0],[[],"CollisionConfiguration",{},0,0],[[],"CollisionInformation",{},0,0],[[],"ResetIgnoredCollision",{},0,0]],[]];
SPLM.Tooling.RunSimulationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.RunSimulationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.RunSimulationBuilder.CollisionCheckOptions = Object.freeze({
    "FacetBodyDistance" : "FacetBodyDistance", "MeshTriangleIntersection" : "MeshTriangleIntersection", "SolidBodyIntersection" : "SolidBodyIntersection"});

export default SPLM;